import { KIND } from 'baseui/tag';
import { SUGGESTION_CATEGORY } from './types';
export const GRAMMAR_SUGGESTION_VALUE = 'Grammar';
export const SOP_RECOMMENDATION_VALUE = 'Suggestion';
export const TRACKING_INCONSISTENCY_VALUE = 'Tracking inconsistency';
export const SUGGESTION_CATEGORY_TO_TITLE_MAP = {
  [SUGGESTION_CATEGORY.SPELLING_AND_GRAMMAR]: GRAMMAR_SUGGESTION_VALUE,
  [SUGGESTION_CATEGORY.SOP_RECOMMENDATIONS]: SOP_RECOMMENDATION_VALUE,
  [SUGGESTION_CATEGORY.TRACKING_INCONSISTENCY]: TRACKING_INCONSISTENCY_VALUE
};
export const SUGGESTION_CATEGORY_TO_COLOR_MAP = {
  [SUGGESTION_CATEGORY.SPELLING_AND_GRAMMAR]: KIND.negative,
  [SUGGESTION_CATEGORY.SOP_RECOMMENDATIONS]: KIND.accent,
  [SUGGESTION_CATEGORY.TRACKING_INCONSISTENCY]: KIND.negative
};
export const ICON_SIZE = '64px';
export const ICON_BORDER_WIDTH = '3px';
export const TRACKING_INCONSISTENCY_SUGGESTION = 'Object movement between frames seems irregular. Review object path and fix tracking if required.';